import React from 'react';

const InboxFilters = ({
  selectedAccount,
  onAccountChange,
  emailAccounts,
  formatEmailAddress,
  showMoreFilters,
  selectedTag,
  onTagChange,
  aiTags,
  tagCounts,
  enthusiasmFilter,
  onEnthusiasmFilterChange,
  warmupCount = 0,
}) => {
  return (
    <>
      {/* Konto-Auswahl-Leiste - nur anzeigen wenn More Filters aktiv */}
      {showMoreFilters && (
        <div className="smartInbox_accounts_bar">
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'all' ? 'active' : ''}`}
            onClick={() => onAccountChange('all')}
          >
            All Inboxes
          </button>
          
          {/* Option für gesendete E-Mails */}
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'sent' ? 'active' : ''}`}
            onClick={() => onAccountChange('sent')}
          >
            Sent
          </button>

          {/* Neue Option für Replied Emails - Unterfilter von Sent Emails */}
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'replied' ? 'active' : ''}`}
            onClick={() => onAccountChange('replied')}
          >
            Replied
          </button>

          {/* Option für weitergeleitete E-Mails */}
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'forwarded' ? 'active' : ''}`}
            onClick={() => onAccountChange('forwarded')}
          >
            Forwarded
          </button>
          
          {/* Option für gelöschte E-Mails */}
    
          
          {/* Option für geplante E-Mails */}
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'scheduled' ? 'active' : ''}`}
            onClick={() => onAccountChange('scheduled')}
          >
            Scheduled
          </button>
          
          {/* NEU: Option für SafeGuard Drafts */}
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'safeguard' ? 'active' : ''}`}
            onClick={() => onAccountChange('safeguard')}
          >
            SafeGuard
          </button>
          
          <button 
            className={`smartInbox_account_button ${selectedAccount === 'deleted' ? 'active' : ''}`}
            onClick={() => onAccountChange('deleted')}
          >
            Deleted
          </button>

          {/* Warmup tab — surfaces all isWarmup === true mail in one place so it
              never clutters the regular inbox. Only rendered when there's
              actually warmup mail; saves vertical space for users who don't
              run warmup yet. */}
          {warmupCount > 0 && (
            <button
              className={`smartInbox_account_button ${selectedAccount === 'warmup' ? 'active' : ''}`}
              onClick={() => onAccountChange('warmup')}
              title="Background warmup mail (auto-replied conversations to build sender reputation)"
            >
              Warmup ({warmupCount})
            </button>
          )}
          {emailAccounts.map((account) => (
            <button 
              key={account.id}
              className={`smartInbox_account_button ${selectedAccount === account.id ? 'active' : ''}`}
              onClick={() => onAccountChange(account.id)}
              title={account.email}
            >
              {formatEmailAddress(account.email)}
            </button>
          ))}
        </div>
      )}

      {/* AI Tag-Filter-Leiste - nur anzeigen wenn More Filters aktiv */}
      {showMoreFilters && selectedAccount !== 'sent' && selectedAccount !== 'replied' && selectedAccount !== 'forwarded' && selectedAccount !== 'scheduled' && selectedAccount !== 'deleted' && selectedAccount !== 'warmup' && aiTags.length > 0 && (
        <div className="smartInbox_filter_bar smartInbox_tag_filter_bar" style={{ marginBottom: '10px', marginTop: '-5px' }}>
          <span className="smartInbox_filter_label">Filter by AI Tag:</span>
          <button 
            className={`smartInbox_filter_button ${selectedTag === 'all' ? 'active' : ''}`}
            onClick={() => onTagChange('all')}
          >
            All Tags
          </button>
          {aiTags.map((tag) => {
            // NEU: Verwende die Zählungen aus Firestore
            const emailsWithTag = tagCounts[tag.tag] || 0;
            
            // Nur den Button rendern, wenn es auch E-Mails mit diesem Tag gibt
            return emailsWithTag > 0 ? (
              <button 
                key={tag.id}
                className={`smartInbox_filter_button ${selectedTag === tag.tag ? 'active' : ''}`}
                onClick={() => onTagChange(tag.tag)}
                style={{
                  backgroundColor: selectedTag === tag.tag ? tag.color : 'transparent',
                  color: selectedTag === tag.tag ? '#fff' : tag.color,
                  border: `1px solid ${tag.color}`
                }}
                title={`${tag.name} (${emailsWithTag} emails)`}
              >
                {tag.name} ({emailsWithTag})
              </button>
            ) : null;
          })}
        </div>
      )}

      {/* Enthusiasmus-Filter-Leiste - nur anzeigen wenn More Filters aktiv */}
      {showMoreFilters && selectedAccount !== 'sent' && selectedAccount !== 'replied' && selectedAccount !== 'forwarded' && selectedAccount !== 'scheduled' && selectedAccount !== 'deleted' && selectedAccount !== 'warmup' && (
        <div className="smartInbox_filter_bar">
          <span className="smartInbox_filter_label">Enthusiasm Level:</span>
          <button 
            className={`smartInbox_filter_button ${enthusiasmFilter === 'all' ? 'active' : ''}`}
            onClick={() => onEnthusiasmFilterChange('all')}
          >
            All Emails
          </button>
          <button 
            className={`smartInbox_filter_button enthusiasm_high ${enthusiasmFilter === 'enthusiastic' ? 'active' : ''}`}
            onClick={() => onEnthusiasmFilterChange('enthusiastic')}
          >
            Enthusiastic (≥5)
          </button>
        </div>
      )}
    </>
  );
};

export default InboxFilters; 